import { render, staticRenderFns } from "./instagram-story-vs-reels-whats-the-difference.vue?vue&type=template&id=bcc11dca"
import script from "./instagram-story-vs-reels-whats-the-difference.vue?vue&type=script&lang=js"
export * from "./instagram-story-vs-reels-whats-the-difference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports